import { doc, getDoc, increment } from 'firebase/firestore';
import uniqid from 'uniqid';
import { Wallet, WalletLog } from '../../apiTypes';
import { db } from '../../firebase';
import { createBatch } from '../../utils/api';
import getDateKey from '../../utils/dates/getDateKey';

type Props = {
  cafeSlug: string;
  log: DbDocument<WalletLog>;
  workerId: string;
  workerName: string;
  wallet: DbDocument<Wallet>;
};

const cancelTransaction = async ({ log, workerId, workerName, wallet, cafeSlug }: Props) => {
  const cancelLog: WalletLog = {
    time: new Date().getTime(),
    sum: -log.sum,
    workerId,
    workerName,
    category: log.category,
    bankCommission: log.bankCommission,
    wallet: wallet.id,
    total: wallet.balance - log.sum + (log.bankCommission || 0),
    info: { type: 'cancel', canceledLog: { info: log.info, id: log.id, time: log.time, comment: log.comment } },
    type: 'cancel',
    comment: '',
  };

  const batch = createBatch();

  const reportDocRef = doc(db, 'cafes', cafeSlug, 'archivedWalletLogs', `${getDateKey(log.time)}`);
  const reportDocSnap = await getDoc(reportDocRef);

  if (reportDocSnap.exists()) {
    batch.delete(`cafes/${cafeSlug}/archivedWalletLogs/${reportDocSnap.id}`);
  }

  batch.update<Wallet>(`cafes/${cafeSlug}/wallets/${wallet.id}`, {
    balance: increment(-log.sum + (log.bankCommission || 0)) as unknown as number,
  });
  batch.update(`cafes/${cafeSlug}/wallets/${wallet.id}/logs/${log.id}`, {
    canceled: true,
  });
  batch.set<WalletLog>(`cafes/${cafeSlug}/wallets/${wallet.id}/logs/${uniqid()}`, cancelLog);
  await batch.commit();
};

export default cancelTransaction;
